import { CategoryModel, ItemSearchOptions } from "models";
import React from "react";
import ItemListSideMenuTreeNode from "./ItemListSideMenuTreeNode";

type PROPS = {
  options: ItemSearchOptions;
  category?: CategoryModel;
  onSelect: (target: CategoryModel) => void;
};

const ItemListSideMenu: React.FC<PROPS> = (props) => {
  return (
    <div className="w-80 bg-slate-200 min-w-max">
      <div className="my-8 mx-4 flex flex-col gap-4">
        <ItemListSideMenuTreeNode
          options={props.options}
          category={props.category}
          onSelect={props.onSelect}
        />
      </div>
    </div>
  );
};

export default ItemListSideMenu;
